import { render, staticRenderFns } from "./BlogSlider.vue?vue&type=template&id=3d272dbd&scoped=true&"
import script from "./BlogSlider.vue?vue&type=script&lang=js&"
export * from "./BlogSlider.vue?vue&type=script&lang=js&"
import style0 from "./BlogSlider.vue?vue&type=style&index=0&id=3d272dbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d272dbd",
  null
  
)

export default component.exports